import { Cookies } from 'quasar';

export function tokenSuez () {
  return 'Bearer ' + Cookies.get('_id');
}

export function isLoggedIn () {
  return Cookies.get('_id') != null;
}

export function isLoggedInApp (state) {
  if (state.user === undefined) return false;
  if (state.user.apps === undefined) return false;
  if (state.user.apps.TSZ === undefined) return false;
  if (state.user.apps.TSZ.rolAplicacion === -1) return false;
  return true;
}

export function isDebugMode () {
  return process.env.NODE_ENV !== 'production';
}

export function baseURL () {
  return process.env.VUE_APP_API_URL;
}

export function CargaFacturasDirectory () {
  return process.env.VUE_APP_CARGA_FACTURAS_DIRECTORY;
}

export function isSA (state) {
  if (state.user === undefined) return false;
  if (state.user.apps === undefined) return false;
  if (state.user.apps.TSZ === undefined) return false;
  return state.user.apps.TSZ.rolAplicacion === 3;
}

export function rolAplicacion (state) {
  if (state.user === undefined) return -1;
  if (state.user.apps === undefined) return -1;
  if (state.user.apps.tsz === undefined) return -1;
  return state.user.apps.tsz.rolAplicacion;
}

export function userMail (state) {
  if (state.user.mail === undefined) return '';
  return state.user.mail;
}

export function CargaAccesoAdmin () {
  return process.env.VUE_APP_ACCESO_ADMIN;
}

export function CargaDatosBeneficio (state) {
  return state.DatosComparativa.Beneficio;
}

export function CargaDatosCostes (state) {
  return state.DatosComparativa.Costes;
}

export function CargaDatosTiempos (state) {
  return state.DatosComparativa.Tiempos;
}

export function CargaDatosListadoPresupuestos (state) {
  return state.DatosListadoPresupuestos;
}

export function isOffline (state) {
  return state.isOffline;
}

export function hayDatos (state) {
  return state.hayDatos;
}

export function idComparativa (state) {
  return state.idComparativa;
}
